export const PRODUCT_SEARCH_THRESHOLD = 6;
